// Helper function to extract age number from string
function extractAgeNumber(ageString: string | undefined): number | null {
  if (!ageString) return null
  const matches = ageString.match(/\d+/)
  return matches ? parseInt(matches[0]) : null
}

export function transformAgeRangeFromAlgolia(
  minimumAge: string | undefined,
  maximumAge: string | undefined,
): string {
  const minAge = extractAgeNumber(minimumAge)
  const maxAge = extractAgeNumber(maximumAge)

  const isInvalidMaxAge = maxAge === null || maxAge > 100
  const isInvalidMinAge = minAge === null

  if (isInvalidMaxAge && isInvalidMinAge) {
    return 'All'
  }

  if (isInvalidMaxAge && !isInvalidMinAge) {
    return `${minAge}+`
  }

  if (isInvalidMinAge && !isInvalidMaxAge) {
    return `< ${maxAge}`
  }

  return `${minAge} - ${maxAge}`
}

export function isAgeRangeGeneric({
  maximumAge,
  minimumAge,
}: {
  maximumAge?: string
  minimumAge?: string
}) {
  const minAge = extractAgeNumber(minimumAge)
  const maxAge = extractAgeNumber(maximumAge)

  // All
  if (minAge === null && maxAge === null) {
    return true
  }

  // 18+
  if (minAge === 18 && maxAge === null) {
    return true
  }

  // 18-N where N is greater than 65
  if (minAge === 18 && maxAge && maxAge > 65) {
    return true
  }

  return false
}
